const RupeeIcon = ({ size = 24, ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M7.30499 3.90771H9.50999C11.6662 3.90771 14.0437 4.62021 14.0437 7.90146C14.0437 11.4602 11.025 12.8215 7.82249 12.4615C7.78463 12.458 7.74661 12.4662 7.71348 12.4848C7.68035 12.5035 7.65368 12.5318 7.637 12.5659C7.62032 12.6001 7.61443 12.6386 7.6201 12.6761C7.62577 12.7137 7.64273 12.7487 7.66874 12.7765L14.4787 20.0927"
                stroke="#0069AD"
                strokeWidth="1.125"
                strokeLinecap="round"
            />
            <path
                d="M16.6425 3.90771H9.02625"
                stroke="#0069AD"
                strokeWidth="1.125"
                strokeLinecap="round"
            />
            <path
                d="M7.41376 8.01367H16.695"
                stroke="#00A7E4"
                strokeWidth="1.125"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default RupeeIcon;